import React, {Component} from "react";
import {Dialog, Menu} from 'evergreen-ui'

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {
    changeTranslationSelectorState,
    changeTranslationTargetLanguage
} from '../redux/Tracefully/AppSettings';

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        changeTranslationSelectorState: changeTranslationSelectorState,
        changeTranslationTargetLanguage: changeTranslationTargetLanguage
    }, dispatch)
};
const mapStateToProps = function (state) {
    return {
        AppSettings: state.AppSettings
    }
};


class TranslationSelectorDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Languages: [
                { label: 'English', value: 'en' },
                { label: 'German', value: 'de' },
                { label: 'Italian', value: 'it' },
                { label: 'Arabic', value: 'ar' },
                { label: 'Japanese', value: 'ja' },
                { label: 'Korean', value: 'ko' },
                { label: 'Bulgarian', value: 'bg' },
                { label: 'Chinese Simplified', value: 'zh-CN' },
                { label: 'Chinese Traditional', value: 'zh-TW' },
                { label: 'Croatian', value: 'hr' },
                { label: 'Czech', value: 'cs' },
                { label: 'Norwegian', value: 'no' },
                { label: 'Danish', value: 'da' },
                { label: 'Portuguese', value: 'pt' },
                { label: 'Russian', value: 'ru' },
                { label: 'Georgian', value: 'ka' },
                { label: 'Swedish', value: 'sv' },
                { label: 'Greek', value: 'el' },
                { label: 'Thai', value: 'th' },
                { label: 'Turkish', value: 'tr' },
                { label: 'Ukrainian', value: 'uk' },
                { label: 'Hungarian', value: 'hu' },
                { label: 'Indonesian', value: 'id' },
            ],
            LanguageMap:{
                'en':'English',
                'de':'German',
                'it':'Italian',
                'ar':'Arabic',
                'ja':'Japanese',
                'ko':'Korean',
                'bg':'Bulgarian',
                'zh-CN':'Chinese Simplified',
                'zh-TW':'Chinese Traditional',
                'hr':'Croatian',
                'cs':'Czech',
                'no':'Norwegian',
                'da':'Danish',
                'pt':'Portuguese',
                'ru':'Russian',
                'ka':'Georgian',
                'sv':'Swedish',
                'el':'Greek',
                'th':'Thai',
                'tr':'Turkish',
                'uk':'Ukrainian',
                'hu':'Hungarian',
                'id':'Indonesian',
            },
            targetLanguage:'en'
        };
        this.closeDialog = this.closeDialog.bind(this);
        this.applyLanguage = this.applyLanguage.bind(this);

    }

    componentDidMount() {
        this.setState({targetLanguage:this.props.AppSettings.translationTargetLanguage.geo})
    }


    closeDialog() {
        this.props.changeTranslationSelectorState(false);

    }

    applyLanguage(){
        console.log(this.state.targetLanguage);
        let temp ={
            geo:this.state.targetLanguage,
            name : this.state.LanguageMap[this.state.targetLanguage]
        }
        this.props.changeTranslationTargetLanguage(temp);
        this.props.changeTranslationSelectorState(false);
    }



    render() {

        return (
            <Dialog isShown={this.props.AppSettings.translationSelectorState}
                    title="Select Language"
                    onCloseComplete={() => this.closeDialog()}
                    onConfirm={() => this.applyLanguage()}
                    confirmLabel="Apply Language">
                <Menu.OptionsGroup
                    options={this.state.Languages}
                    selected={this.state.targetLanguage}
                    onChange={selected => this.setState({ targetLanguage:selected })}
                />
            </Dialog>


        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
) (TranslationSelectorDialog);
